import React, { Component } from 'react'

import PropTypes from 'prop-types'
import moment from 'moment'

import { getPlaceInfoById } from './../../libs/utils'
import { NotificationManager } from 'react-notifications'

export default class TransportationForm extends Component {
  static propTypes = {
    onFormFieldChange: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    dates: PropTypes.array.isRequired
  }

  static defaultProps = {
    dates: []
  }

  constructor(props) {
    super(props)

    this.state = {
      departure: '',
      departureAddress: '',
      departureDate: moment().startOf('day'),
      departureTime: moment().startOf('day'),
      arrival: '',
      arrivalAddress: '',
      arrivalDate: moment().startOf('day'),
      arrivalTime: moment().startOf('day'),
      type: 'Transportation'
    }

    this.onDateChange = this.onDateChange.bind(this)
    this.checkStartDate = this.checkStartDate.bind(this)
    this.checkEndDate = this.checkEndDate.bind(this)
    this.onPlaceChange = this.onPlaceChange.bind(this)
  }

  onPlaceChange(place, placeId, type) {
    this.setState(
      {
        [type]: place
      },
      async () => {
        let placeInfo

        try {
          placeInfo = await getPlaceInfoById(placeId)
        } catch (err) {
          NotificationManager.error(err.message, 'Error', 5000)
        }

        this.setState({
          [`${type}Address`]: placeInfo.formatted_address
        })

        this.props.onFormFieldChange(`eventDetails.transportationDetails.${type}`, place)
      }
    )
  }

  onDateChange(key, value, isMomentNeeded) {
    this.setState(
      {
        [key]: isMomentNeeded ? moment(value) : value
      },
      () => {
        if (this.state.arrivalDate.isBefore(this.state.departureDate)) {
          this.setState(
            {
              arrivalDate: this.state.departureDate.clone().set({
                hours: this.state.arrivalTime.hours(),
                minutes: this.state.arrivalTime.minutes()
              })
            },
            () => {
              this.props.onFormFieldChange('endDate', this.state.arrivalDate.toISOString())
            }
          )
        }

        this.checkStartDate()
        this.checkEndDate()
      }
    )
  }

  checkStartDate() {
    const startDate = this.state.departureDate.clone().set({
      hours: this.state.departureTime.hours(),
      minutes: this.state.departureTime.minutes()
    })

    this.props.onFormFieldChange('startDate', startDate.toISOString())
  }

  checkEndDate() {
    const endDate = this.state.arrivalDate.clone().set({
      hours: this.state.arrivalTime.hours(),
      minutes: this.state.arrivalTime.minutes()
    })

    this.props.onFormFieldChange('endDate', endDate.toISOString())
  }
}



// WEBPACK FOOTER //
// src/components/Event/TransportationForm.js